import { axios, DELETE, GET, PUT, POST  } from 'app-api-user-service'

export default axios

export { DELETE, GET, PUT, POST }
